module.exports = __webpack_public_path__ + "static/media/dangerous-waste.88ed1224.png";